<div class="paginationWrapper">
	<ul [class.hidden]="pageIndices.length <= 1">
		@for (page of pageIndices; track page) {
			<li (click)="autoLoopInterval() === 0 && setPage(page)" [class.active]="activePage === page">
				<div class="pageDot"></div>
				@if (autoLoopInterval()) {
					<mat-progress-spinner
						color="accent"
						[value]="loopIntervalPercentage()"
						[diameter]="22"
						[class.hidden]="activePage !== page"
					/>
				}
			</li>
		}
	</ul>
</div>
